import React, { useState, useEffect } from 'react';


const ImageContainer = ({ src, alt, className, width, height, loading, url }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const aspectRatio = 2;

  const webpImageURL = cdnBase + src.replace(".png", ".webp");
  useEffect(() => {
    const img = new Image();
    img.src = webpImageURL;
    img.onload = handleImageLoaded;
    img.onerror = handleImageError;
  }, [src]);

  const handleImageLoaded = () => {
    setIsLoaded(true);
  };

  const handleImageError = () => {
    setHasError(true);
  };

  return (
    <div className="image-container"
    style={{
      position: 'relative',
      width: '100%',
      paddingTop: `${aspectRatio}%`, // Maintain aspect ratio
      overflow: 'hidden',
    }}
    >
    {!isLoaded && !hasError && (
      <div className="loader-container">
        <div className="loader spinner"></div>
      </div>
    )}
    {!hasError && isLoaded && (
      <img
        itemProp="image"
        alt={alt}
        className={className}
        onLoad={handleImageLoaded}
        onError={handleImageError}
        src={webpImageURL}
        data-src={webpImageURL}
        loading={loading}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover', // Maintain the image within the container without distortion
          display: isLoaded ? 'inline-block' : 'none', // Hide the image until loaded
        }}
      />
    )}
    {hasError && (
      <div className="error-placeholder">
        Failed to load image.
      </div>
    )}
  </div>
  );
};

export default ImageContainer;
